// extracted by mini-css-extract-plugin
module.exports = {"container":"sorting_container__38LGQ","content":"sorting_content__18OzZ"};